module.exports = __webpack_public_path__ + "img/login-v2.bdb974c1.svg";